<template>
  <ORow fill-x top class="my-6">
    <OCol>
      <div>
        Este botão permite copiar todas as linhas de dados para o clipboard.
        Cada linha possui data, hora, o crachá associado, o valor do PGN e o hex
        que a gerou.
      </div>
      <v-btn @click="copyTableToClipboard">
        <v-icon class="mr-2" small>mdi-clipboard-outline</v-icon>
        Copiar Linhas ({{ rows.length }})
      </v-btn>
    </OCol>

    <OCol class="px-6">
      <div>
        Este botão permite copiar todas as diferentes variáveis encontradas em
        todas as linhas. Cada variável é uma string de 3 bytes em hex.
      </div>
      <v-btn @click="copyVariablesToClipboard">
        <v-icon class="mr-2" small>mdi-clipboard-outline</v-icon>
        Copiar Variáveis ({{ allVariables.length }})
      </v-btn>
    </OCol>

    <OCol>
      Este botão copia uma lista inicial de PlotConfigs, com uma config para
      cada byte de cada variável. O valor pode ser colado diretamente na caixa
      "PlotConfigs" acima.
      <v-btn @click="copyPlotsToClipboard">
        <v-icon class="mr-2" small>mdi-clipboard-outline</v-icon>
        Copiar PlotConfigs iniciais ({{ allPlots.length }})
      </v-btn>
    </OCol>
  </ORow>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    rows: { required: true }
  },
  computed: {
    sniffCsv() {
      let result = [['data', 'hora', 'card?', 'pgn', 'hex'].join(';')]

      for (let frame of this.rows) {
        let t = moment(frame.timestamp)
        let d = t.format('YYYY-MM-DD')
        let h = t.format('HH:mm:ss')
        let c = frame.hasCard ? frame.cardLabel : ''

        let sample = frame.sample
        if (sample.length < 1)
          sample = [{ code: '------', hexValue: '----------------' }]

        for (let variable of sample) {
          let line = [d, h, c, variable.code, variable.hexValue]
          result.push(line.join(';'))
        }
      }

      return result
    },

    allVariables() {
      let result = new Set()
      for (let frame of this.rows) {
        for (let variable of frame.sample) {
          result.add(variable.code)
        }
      }

      return [...result].sort()
    },

    allPlots() {
      let result = []
      let p = (x) => x.toString().padStart(2, '0')
      for (let code of this.allVariables) {
        for (let i = 0; i < 8; i++) {
          result.push(`${code} ${p(i * 8)} ${p((i + 1) * 8)}`)
        }
      }
      return result
    }
  },
  methods: {
    copyTableToClipboard() {
      navigator.clipboard.writeText(this.sniffCsv.join('\n'))
      this.$snack(`CSV copiado`)
    },

    copyVariablesToClipboard() {
      navigator.clipboard.writeText(this.allVariables)
      this.$snack(`Variáveis copiadas`)
    },

    copyPlotsToClipboard() {
      navigator.clipboard.writeText(this.allPlots.join('\n'))
      this.$snack(`PlotConfig copiado`)
    }
  }
}
</script>

<style></style>
